import React from "react";
import { useState } from "react";
import ReactSelect from "react-select";
import Common from "../Common";
import CustomOption from "./CustomOption";

class ToggleCellEditor extends Common {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      options: [
        { value: "false", label: "False" },
        { value: "true", label: "True" },
      ],
    };
  }

  getValue = () => {
    return this.state.value;
  };

  // any cleanup we need to be done here
  destroy = () => {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
  };

  // if true, then this editor will appear in a popup
  isPopup = () => {
    // and we could leave this method out also, false is the default
    return false;
  };
  componentDidMount() {
    this.setState((state) => {
      return {
        ...state,
        value: this.props?.value?.value || this.props?.value,
      };
    });
    this.focusInput();
  }

  focusInput = () => {
    setTimeout(() => {
      if (this.selectRef) {
        this.selectRef.focus();
      }
    }, 0);
  };
  handleChange = (selectedOption) => {
    console.log(selectedOption);
    this.setState(
      (state) => {
        return {
          ...state,
          value: selectedOption.value,
        };
      },
      () => {
        this.props.api.stopEditing(); // Stop editing the cell
        this.props.api.applyTransaction({
          update: [{ ...this.props.node.data, column: selectedOption.value }],
        }); // Update the data source
        this.props.api.refreshCells({ rowNodes: [this.props.node] }); // Refresh the grid to reflect the updated data
      }
    );
  };
  render() {
    console.log(this.state.value, 34243254354343);
    const menuPortalTarget = document.body;
    return (
      <ReactSelect
        menuIsOpen={true}
        value={this.state.options.filter((it) => it.value == this.state.value)}
        options={this.state.options}
        className="assignClass"
        onChange={this.handleChange}
        menuPortalTarget={menuPortalTarget}
        styles={{
          zIndex: 999999,
          width: this.props.colDef.width,
          control: (provided) => ({ ...provided, width: "100%" }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            width: this.props.colDef.width,
          }),
          menuList: (provided) => ({
            ...provided,
            width: this.props.colDef.width,
            height: 200,
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        menuPlacement="auto"
        ref={(ref) => (this.selectRef = ref)}
      />
    );
  }
}

export default ToggleCellEditor;
